import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MetaService } from '../../../services/meta.service';

@Component({
  selector: 'app-mobile-development',
  templateUrl: './mobile-development.component.html',
  styleUrls: ['./mobile-development.component.scss']
})
export class MobileDevelopmentComponent implements OnInit {
  imageUrl!: string;
  contentTitle = 'Mobile Development - Xipe Tech';
  contentDescription = 'Discover XipeTech’s expert Mobile Development services. We create high-performance, user-friendly mobile apps that solve business challenges with innovative technology and responsive design.';
  contentKeywords = 'mobile app development, mobile application services, iOS app development, Android app development, cross-platform mobile apps, custom mobile solutions, XipeTech mobile development, enterprise mobile apps, mobile UI/UX design, app maintenance services';
  pageUrl!: string;
  siteTitle = 'Revolutionary IT Solutions – XipeTech';
  ext = 'png';

  constructor(private metaService: MetaService, private router: Router) { }

  ngOnInit(): void {
    const baseUrl = window.location.origin;
    // Set the page title
    this.metaService.setMetaData({
      title: this.contentTitle,
      description: this.contentDescription,
      keywords: this.contentKeywords,
      siteTitle: this.siteTitle,
      pageUrl: `${baseUrl}${this.router.url}`,
      imageUrl: `${baseUrl}/assets/img/xipetech.png`,
      ext: this.ext
    });
  }
}
